<template>
  <div class="header-container" :class="{ 'animation-top' : scrollTop === 0 }">
    <div class="wrap">
      <a href="https://www.way-s.cn/"><img class="img" src="https://www.way-s.cn/imgs/logo.png" alt="" /></a>
      <div class="mune-container">
        <div v-for="menu in menuOptions" :key="menu.label">
          <div v-if="menu.showArrow" class="mune-item arrow">
            {{ menu.label }}
            <div v-if="menu.showArrow" class="children-container">
              <a v-for="item in menu.children" :key="item.label" :href="item.href" class="item">{{ item.label }}</a>
            </div>
          </div>
          <a v-else :href="menu.href">{{ menu.label }}</a>
        </div>
      </div>
      <div class="menu" @click="showMenu=true">☰</div>
    </div>
    <MenuComponent v-model="showMenu" />
  </div>
</template>

<script>
import MenuComponent from './menu'
export default {
  components: { MenuComponent },
  props: {},
  data () {
    return {
      scrollTop: 0,
      showMenu: false,
      menuOptions: [
        {
          label: '关于威尔森',
          showArrow: true,
          children: [
            {
              label: '了解威尔森',
              href: 'https://www.way-s.cn/About-WAYS.html'
            },
            {
              label: '企业文化',
              href: 'https://www.way-s.cn/Company-Culture.html'
            },
            {
              label: '威尔森观点',
              href: 'https://www.way-s.cn/news.html'
            },
            {
              label: '联系我们',
              href: 'https://www.way-s.cn/Contact-Us.html'
            }
          ]
        },
        {
          label: '智域',
          href: ''
        },
        {
          label: '智库',
          href: 'https://i.way-s.cn'
        },
        {
          label: '达示数据',
          href: 'http://www.daas-auto.com'
        }
      ]
    }
  },
  mounted () {
    window.addEventListener('scroll', this.listennerScroll)
  },
  unmounted () {
    window.removeEventListener('scroll', this.listennerScroll)
  },
  methods: {
    listennerScroll () {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // console.log(scrollTop, window.innerHeight)
      this.scrollTop = scrollTop
      this.$emit('on-scroll', scrollTop)
    }
  }
}
</script>

<style lang="less" scoped>
// .animation-top {
//   padding-top: 47px !important;
// }
.header-container {
  transition: all 1s;
  padding-top: 0;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #fff;
  box-shadow: 0px 1px 0px 0px rgba(0,0,0,0.03);box-shadow: 0px 3px 6px 0px rgba(24,28,40,0.02);
  display: flex;
  justify-content: center;
  .wrap {
    width: 1220px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .img {
      width: 160px;
      height: 48px;
    }
    .menu {
      display: none;
    }
    .mune-container {
      display: flex;
      align-items: center;
      .mune-item, a {
        position: relative;
        cursor: pointer;
        font-size: 18px;
        margin-right: 40px;
        color: #313234;
        &.arrow {
          padding-right: 20px;
          background: url('https://www.way-s.cn/imgs/zys23.png') no-repeat right center;
        }
        &:hover {
          color: #0c4f8a;
          .children-container {
            display: block;
          }
        }
      }
      .children-container {
        display: none;
        position: absolute;
        z-index: 999;
        padding: 6px 15px;
        background-color: #fff;
        text-align: left;
        .item {
          font-size: 14px;
          line-height: 36px;
          color: #313234;
          display: block;
          white-space: nowrap;
          &:hover {
            color: #0c4f8a;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .header-container {
    height: 44px;
    .wrap {
      padding: 0 24px;
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .img {
        height: 30px;
        // width: 64px;
        width: calc(30px * 160 / 48);
      }
      .mune-container {
        display: none;
      }
      .menu {
        display: block;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #000;
        font-weight: 600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/header.vue